import Language from "@/domain/enums/Language";
import { enUS, fr } from "date-fns/locale";

const useGetDateFnsLocale = (language: Language) => {
    switch (language) {
        case Language.FRENCH:
            return fr;
        case Language.ENGLISH:
            return enUS;
        default:
            return enUS;
    }
};

export default useGetDateFnsLocale;
